import DeliveryAndBillingForm from "@/components/templates/Checkout/forms/delivery-and-billing-form";
import { getLocalFromPrismic, getPrismicLocale } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { getDocument } from "@/lib/prismic";
import { getCheckoutBackRoute } from "@/lib/utils";
import type { NavigationDocument } from "@/prismicio-types";
import { isFilled } from "@prismicio/client";
import { ChevronLeft } from "lucide-react";
import Link from "next/link";
import { use } from "react";

type DeliveryDetailsProps = {
  resolution: Resolution;
};

const DELIVERY_PICK_UP_FAQ_UID = "livraison-et-reprise" as const;

const DeliveryDetails = ({ resolution }: DeliveryDetailsProps) => {
  const sidebarData = use(getDocument("navigation", "faq", resolution.locale)) as NavigationDocument;
  const deliveryFaqLink = sidebarData.data.slices.find((slice) => {
    const ref = slice.primary.link;
    if (ref.link_type === "Document" && isFilled.link(ref)) {
      return ref.uid === DELIVERY_PICK_UP_FAQ_UID;
    }
    return "";
  });

  const rawdeliveryFaqUrl =
    deliveryFaqLink?.primary.link.link_type === "Document" &&
    isFilled.link(deliveryFaqLink.primary.link) &&
    deliveryFaqLink.primary.link.url;

  let deliveryFaqUrl = rawdeliveryFaqUrl
    ?.toString()
    .replace(`/${getPrismicLocale(resolution.locale)}`, getLocalFromPrismic(getPrismicLocale(resolution.locale)))
    .replace("fr", "");

  if (deliveryFaqUrl?.startsWith("/")) {
    deliveryFaqUrl = deliveryFaqUrl.slice(1);
  }

  const [route] = resolution.slugs;
  return (
    <article className="flex-3/5 space-y-5">
      <Link
        href={getCheckoutBackRoute(resolution.locale, route)}
        className="text-blue-brand flex w-fit items-center gap-2.5 pr-1 font-medium transition-transform duration-150 ease-in-out active:scale-95 max-md:hidden"
      >
        <ChevronLeft size={24} aria-hidden="true" />
        {__("Return to the previous step", resolution.locale)}
      </Link>
      <h2 className="font-cabinet-grotesk text-2xl font-medium md:text-3xl">
        {__("Delivery and invoicing", resolution.locale)}
      </h2>
      <hr className="border-primary-light/50" />
      <DeliveryAndBillingForm route={route} locale={resolution.locale} deliveryFaqUrl={deliveryFaqUrl} />
    </article>
  );
};

export default DeliveryDetails;
